(() => {
  const header = document.querySelector("[data-moya-header]");
  const toggle = document.querySelector("[data-moya-menu-toggle]");

  let lastScrollY = window.scrollY;
let headerTicking = false;

const syncHeader = () => {
  if (!header) return;

  const currentScrollY = window.scrollY;
  const scrollingDown = currentScrollY > lastScrollY;
  const pastHeader = currentScrollY > 120;

  header.classList.toggle("is-scrolled", currentScrollY > 16);
  header.classList.toggle(
    "is-hidden",
    scrollingDown && pastHeader && !header.classList.contains("is-menu-open")
  );

  lastScrollY = currentScrollY;
};

syncHeader();

window.addEventListener("scroll", () => {
  if (headerTicking) return;

  window.requestAnimationFrame(() => {
    syncHeader();
    headerTicking = false;
  });

  headerTicking = true;
}, { passive: true });

  if (header && toggle) {
    toggle.addEventListener("click", () => {
      const open = header.classList.toggle("is-menu-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  const initCarousels = (root = document) => {
    root.querySelectorAll("[data-moya-carousel]").forEach((carousel) => {
      if (carousel.dataset.moyaCarouselReady === "true") return;

      const track = carousel.querySelector("[data-moya-carousel-track]");
      const slides = Array.from(carousel.querySelectorAll("[data-moya-carousel-slide]"));
      const prev = carousel.querySelector("[data-moya-carousel-prev]");
      const next = carousel.querySelector("[data-moya-carousel-next]");
      const dotsWrap = carousel.querySelector("[data-moya-carousel-dots]");
      const dots = Array.from(carousel.querySelectorAll("[data-moya-carousel-dot]"));
      let index = 0;

      if (!track || slides.length === 0) return;
      carousel.dataset.moyaCarouselReady = "true";

      if (slides.length < 2) {
        if (prev) prev.hidden = true;
        if (next) next.hidden = true;
        if (dotsWrap) dotsWrap.hidden = true;
      }

      const show = (nextIndex) => {
        index = (nextIndex + slides.length) % slides.length;
        track.style.transform = `translateX(-${index * 100}%)`;

        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === index;
          slide.classList.toggle("is-active", active);
          slide.setAttribute("aria-hidden", active ? "false" : "true");
        });

        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle("is-active", active);
          dot.setAttribute("aria-current", active ? "true" : "false");
        });
      };

      if (prev) {
        prev.addEventListener("click", () => show(index - 1));
      }

      if (next) {
        next.addEventListener("click", () => show(index + 1));
      }

      dots.forEach((dot, dotIndex) => {
        dot.addEventListener("click", () => show(dotIndex));
      });

      let touchStartX = 0;
      let touchStartY = 0;

      track.addEventListener("touchstart", (event) => {
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
      }, { passive: true });

      track.addEventListener("touchend", (event) => {
        const touchEndX = event.changedTouches[0].clientX;
        const touchEndY = event.changedTouches[0].clientY;
        const diffX = touchEndX - touchStartX;
        const diffY = touchEndY - touchStartY;

      if (Math.abs(diffX) < 40 || Math.abs(diffX) < Math.abs(diffY)) return;

      if (diffX < 0) {
        show(index + 1);
      } else {
      show(index - 1);
      }
      }, { passive: true });
      show(0);
    });
  };

  initCarousels();
  document.addEventListener("shopify:section:load", (event) => initCarousels(event.target));

  document.querySelectorAll("[data-moya-hotspot]").forEach((hotspot) => {
    const button = hotspot.querySelector("button");
    if (!button) return;
    button.addEventListener("click", () => {
      hotspot.classList.toggle("is-open");
    });
  });
})();
